import * as renamingActions from './actions';
import Notifications from 'react-notification-system-redux';
import { getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import { Messages } from './model';
import { getName, getNode } from './selectors';
import { api } from '../../../general/apiScenarios';
import { logger } from '../../logger';
import { _select, ListenerApiLight, lm } from '../../listenerMiddleware';
import { APIScenarioReturn } from '../../../general/apiSagaFactory';
import { Interrupt } from '../../../general/scenarioFactory';
import { INode } from '../../../general/model';

export function renamingRootListener() {
  lm.takeEvery(renamingActions.confirmed, async (_, lapi) => {
    const renameResult = await renameNode(lapi);
    lapi.signal.throwIfAborted();
    if (!renameResult.success) {
      return;
    }
    lapi.dispatch(renamingActions.modalClosed());
  });
  lm.takeEvery(renamingActions.modalOpenUiEvent, (_, lapi) => {
    const selectedNodes = _select(lapi, getSelectedNodesInAllFolders);
    const node = selectedNodes[0];
    lapi.dispatch(renamingActions.modalOpened({ node }));
  });
  lm.takeEvery(renamingActions.modalCloseUiEvent, (_, lapi) => {
    lapi.dispatch(renamingActions.modalClosed());
  });
  lm.takeEvery(renamingActions.renameButtonClicked, (_, lapi) => {
    lapi.dispatch(renamingActions.modalOpenUiEvent());
  });
}

async function renameNode(lapi: ListenerApiLight): Promise<APIScenarioReturn<{ node: INode }>> {
  const name = _select(lapi, getName);
  const node = _select(lapi, getNode);
  if (node === null) {
    return { success: false, reason: Interrupt.Exception('getNode() returned null'), args: [] };
  }
  lapi.dispatch(renamingActions.setProgress({ inProgress: true }));
  const renameResult = await api.fs.rename(name, node.id);
  lapi.signal.throwIfAborted();
  lapi.dispatch(renamingActions.setProgress({ inProgress: false }));
  if (renameResult.success) {
    logger.lapi(lapi, {
      action: 'File',
      sub_action: 'Rename',
      extra: { int_1: node.id, text_1: name },
    });
    lapi.dispatch(
      renamingActions.nodeChanged({ oldNodeID: node.id, newNode: renameResult.data.response.node }),
    );
  } else {
    try {
      const JSONResponse = renameResult.errorData?.response;
      const msg: string = JSONResponse?.data?.join('; ') ?? '';
      lapi.dispatch(Notifications.error(Messages.renameError(msg)));
    } catch (x) {
      lapi.dispatch(Notifications.error(Messages.renameError('Unknown error during rename')));
    }
  }
  return renameResult;
}
